import React from 'react';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function SSOHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const auth = params.get("auth");
    if (auth) {
      try {
        const payload = JSON.parse(atob(auth));
        secureLocalStorage.setItem("token", payload.access_token);
        secureLocalStorage.setItem("permissions", payload.permissions.join(","));
        secureLocalStorage.setItem("name", payload.profile.name);
        secureLocalStorage.setItem("entity", payload.profile.entity_id);
        secureLocalStorage.setItem("id", payload.profile.id);
        secureLocalStorage.setItem("role", payload.role[0]);
        secureLocalStorage.setItem("avatar_url", payload.profile.avatar);
        secureLocalStorage.setItem("expires_in", payload.expires_in);
        secureLocalStorage.setItem("dt_start_session", new Date());
        localStorage.setItem("menu", "1");
        navigate("/home");
      } catch (e) {
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, [navigate]);

  // Exibe um loading centralizado enquanto processa o SSO
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
